import styled from "styled-components"

import mc from "@irati-web/payments/src/images/mastercard.svg"
import visa from "@irati-web/payments/src/images/visa.svg"
import amex from "@irati-web/payments/src/images/amex.svg"

const icons = {
  mc,
  amex,
  visa
}

interface Props {
  type: "mc" | "amex" | "visa"
}

const Payment = styled.span<Props>`
  background: url(${({type}) => icons[type]});
`

export default Payment
